import {
  ACCOUNT_TOS_ACCEPT,
  ACCOUNT_INTRO_COMPLETE,
  ACCOUNT_WALLET_RESET,
  ACCOUNT_WALLET_SELECT,
  ACCOUNT_NOT_PROVIDED,
  ACCOUNT_REFRESHING,
  ACCOUNT_CHANGE,
  ACCOUNT_CHANGE_FAILED,
  ACCOUNT_BALANCE_UPDATE,
  ACCOUNT_NETWORK_CHANGE,
  ACCOUNT_NETWORK_CHANGE_FAILED,
  CAT_BALANCE_UPDATE,
  CAT_ALLOWANCE_UPDATE,
  ACCOUNT_WALLET_RELOAD_STARTED,
  ACCOUNT_WALLET_RELOAD_COMPLETED,
} from '../actionTypes';

export const getDefaultState = () => ({
  web3Provided: null,
  web3Locked: false,
  address: '',
  balance: null,
  catBalance: null,
  catAllowance: null,
  network: '',
  tosAccepted: false,
  walletType: '',
  walletOptions: {},
  introCompleted: false,
  isWalletReloading: false,
});

const reducer = (state = getDefaultState(), action) => {
  switch (action.type) {
    case ACCOUNT_TOS_ACCEPT:
      return {
        ...state,
        tosAccepted: true,
      };

    case ACCOUNT_INTRO_COMPLETE:
      return {
        ...state,
        introCompleted: true,
      };

    case ACCOUNT_WALLET_RESET:
      return {
        ...state,
        walletType: '',
        walletOptions: {},
        web3Provided: null,
        web3Locked: false,
        address: '',
        balance: null,
        catBalance: null,
        catAllowance: null,
      };

    case ACCOUNT_WALLET_SELECT:
      return {
        ...state,
        walletType: action.walletType,
        walletOptions: action.walletOptions || {},
        address: action.walletOptions.address || '',
      };

    case ACCOUNT_NOT_PROVIDED:
      return {
        ...state,
        web3Provided: false,
      };

    case ACCOUNT_REFRESHING:
      return {
        ...state,
        web3Provided: null,
        web3Locked: false,
      };

    case ACCOUNT_CHANGE:
      return {
        ...state,
        web3Provided: true,
        web3Locked: !action.address,
        address: action.address || '',
        balance: null,
        catBalance: null,
        catAllowance: null,
      };

    case ACCOUNT_CHANGE_FAILED:
      return {
        ...state,
        web3Provided: false,
        web3Locked: false,
        address: '',
      };

    case ACCOUNT_BALANCE_UPDATE:
      return {
        ...state,
        balance: action.balance,
      };

    case ACCOUNT_NETWORK_CHANGE:
      return {
        ...state,
        network: action.network,
      };

    case ACCOUNT_NETWORK_CHANGE_FAILED:
      return {
        ...state,
        network: action.network || state.network,
      };

    case CAT_BALANCE_UPDATE:
      return {
        ...state,
        catBalance: action.balance,
      };

    case CAT_ALLOWANCE_UPDATE:
      return {
        ...state,
        catAllowance: action.allowance,
      };

    case ACCOUNT_WALLET_RELOAD_STARTED:
      return {
        ...state,
        walletType: '',
        walletOptions: {},
        web3Provided: null,
        web3Locked: false,
        address: '',
        balance: null,
        catBalance: null,
        catAllowance: null,
        isWalletReloading: true,
      };

    case ACCOUNT_WALLET_RELOAD_COMPLETED:
      return {
        ...state,
        isWalletReloading: false,
      };

    default:
      return state;
  }
};

export default reducer;



// WEBPACK FOOTER //
// ./src/reducers/account.js